webpackJsonp([10991734084388],{

/***/ "./node_modules/decode-uri-component/index.js":
/***/ (function(module, exports) {

	'use strict';
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp(token, 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');
	
	function decodeComponents(components, split) {
		try {
			// Try to decode the entire string first
			return decodeURIComponent(components.join(''));
		} catch (err) {
			// Do nothing
		}
	
		if (components.length === 1) {
			return components;
		}
	
		split = split || 1;
	
		// Split the array in 2 parts
		var left = components.slice(0, split);
		var right = components.slice(split);
	
		return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}
	
	function decode(input) {
		try {
			return decodeURIComponent(input);
		} catch (err) {
			var tokens = input.match(singleMatcher);
	
			for (var i = 1; i < tokens.length; i++) {
				input = decodeComponents(tokens, i).join('');
	
				tokens = input.match(singleMatcher);
			}
	
			return input;
		}
	}
	
	function customDecodeURIComponent(input) {
		// Keep track of all the replacements and prefill the map with the `BOM`
		var replaceMap = {
			'%FE%FF': '\uFFFD\uFFFD',
			'%FF%FE': '\uFFFD\uFFFD'
		};
	
		var match = multiMatcher.exec(input);
		while (match) {
			try {
				// Decode as big chunks as possible
				replaceMap[match[0]] = decodeURIComponent(match[0]);
			} catch (err) {
				var result = decode(match[0]);
	
				if (result !== match[0]) {
					replaceMap[match[0]] = result;
				}
			}
	
			match = multiMatcher.exec(input);
		}
	
		// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
		replaceMap['%C2'] = '\uFFFD';
	
		var entries = Object.keys(replaceMap);
	
		for (var i = 0; i < entries.length; i++) {
			// Replace all decoded components
			var key = entries[i];
			input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
		}
	
		return input;
	}
	
	module.exports = function (encodedURI) {
		if (typeof encodedURI !== 'string') {
			throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
		}
	
		try {
			encodedURI = encodedURI.replace(/\+/g, ' ');
	
			// Try the built in decoder first
			return decodeURIComponent(encodedURI);
		} catch (err) {
			// Fallback to a more advanced decoder
			return customDecodeURIComponent(encodedURI);
		}
	};


/***/ }),

/***/ "./node_modules/query-string/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__("./node_modules/strict-uri-encode/index.js");
	var objectAssign = __webpack_require__("./node_modules/object-assign/index.js");
	var decodeComponent = __webpack_require__("./node_modules/decode-uri-component/index.js");
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeComponent(val);
	
			formatter(decodeComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),

/***/ "./node_modules/strict-uri-encode/index.js":
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),

/***/ "./src/components/FullPageBlueItem.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _main, _text, _textMobile, _nameMobile, _nameMobileIcon;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__("./node_modules/radium/lib/index.js");
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__("./src/utils/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _utilFunctions = __webpack_require__("./src/utils/util-functions.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlueSingleBox = function (_Component) {
	  _inherits(BlueSingleBox, _Component);
	
	  function BlueSingleBox() {
	    _classCallCheck(this, BlueSingleBox);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  BlueSingleBox.prototype.shortenText = function shortenText(text) {
	    return text && text.length > 32 ? text.substr(0, 32) + ".." : text;
	  };
	
	  BlueSingleBox.prototype.go = function go(url) {
	    if (url.startsWith('http')) {
	      window.location = url;
	    } else {
	      this.props.history.push(url);
	    }
	    return false;
	  };
	
	  BlueSingleBox.prototype.render = function render() {
	    var _this2 = this;
	
	    //Need to add key={x} so Radium works properly
	    return _react2.default.createElement(
	      'div',
	      { style: styles.main },
	      _react2.default.createElement(
	        'div',
	        { className: 'row', style: styles.text, key: 1 },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 hidden-sm hidden-md hidden-lg', style: styles.nameMobile, onClick: function onClick() {
	              return _this2.props.clickExtraText((0, _utilFunctions.prettifyUrl)(_this2.props.name));
	            } },
	          _react2.default.createElement(
	            'span',
	            { style: styles.textMobile },
	            this.props.name
	          ),
	          ' ',
	          _react2.default.createElement('i', { style: styles.nameMobileIcon, className: 'glyphicon glyphicon-chevron-right pull-right' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 hidden-xs', onClick: function onClick() {
	              return _this2.props.clickExtraText((0, _utilFunctions.prettifyUrl)(_this2.props.name));
	            } },
	          this.props.name
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 hidden-xs', key: 2, onClick: function onClick() {
	              return _this2.props.clickExtraText((0, _utilFunctions.prettifyUrl)(_this2.props.name));
	            } },
	          this.props.extraText
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 hidden-xs' },
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this2.go(_this2.props.buttonLink);
	              }, href: this.props.buttonLink, style: styles.button, key: 3 },
	            this.shortenText(this.props.buttonText)
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-3 hidden-xs' },
	          this.props.phoneText,
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { style: styles.phone, key: 4, href: "tel:" + this.props.phone },
	            this.props.phone
	          ),
	          ' '
	        )
	      )
	    );
	  };
	
	  return BlueSingleBox;
	}(_react.Component);
	
	var styles = {
	  main: (_main = {
	    backgroundColor: _colors2.default.darkBrown,
	    padding: 10,
	    marginTop: 10,
	    borderRadius: _breakpoints2.default.borderRadius,
	    ':hover': {
	      backgroundColor: _colors2.default.lightBrown
	    }
	  }, _main[_breakpoints2.default.media.siteUnderPadWidth] = {
	    marginLeft: 0,
	    marginRight: 0
	  }, _main),
	  button: {
	    padding: 8,
	    display: 'block',
	    backgroundColor: '#ffffff',
	    textAlign: 'center',
	    color: _colors2.default.darkBlue,
	    borderRadius: 25,
	    opacity: '0.8',
	    width: '100%',
	    ':hover': {
	      cursor: 'pointer'
	    }
	  },
	  text: (_text = {
	    color: _colors2.default.darkBlue,
	    lineHeight: 1.5,
	    display: 'flex',
	    justifyContent: 'center',
	    alignItems: 'center',
	    padding: 5,
	    ':hover': {
	      cursor: 'pointer'
	    }
	  }, _text[_breakpoints2.default.media.siteUnderPadWidth] = {
	    display: 'block',
	    textAlign: 'left'
	  }, _text),
	  textMobile: (_textMobile = {}, _textMobile[_breakpoints2.default.media.siteUnderPadWidth] = {
	    marginTop: 7,
	    display: 'inline-block'
	  }, _textMobile),
	  nameMobile: (_nameMobile = {}, _nameMobile[_breakpoints2.default.media.siteUnderPadWidth] = {
	    width: '100%'
	  }, _nameMobile),
	  nameMobileIcon: (_nameMobileIcon = {}, _nameMobileIcon[_breakpoints2.default.media.siteUnderPadWidth] = {
	    fontSize: 16,
	    marginTop: 6
	  }, _nameMobileIcon),
	  phone: {
	    color: _colors2.default.darkBlue,
	    textDecoration: 'underline',
	    ':hover': {
	      cursor: 'pointer'
	    }
	  }
	};
	
	exports.default = (0, _radium2.default)(BlueSingleBox);
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/MenuTabs.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MenuTabs = undefined;
	
	var _item, _itemActive;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _breakpoints = __webpack_require__("./src/utils/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _radium = __webpack_require__("./node_modules/radium/lib/index.js");
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _marked = __webpack_require__("./node_modules/marked/lib/marked.js");
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _utilFunctions = __webpack_require__("./src/utils/util-functions.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuTabs = exports.MenuTabs = function (_Component) {
	  _inherits(MenuTabs, _Component);
	
	  function MenuTabs(props, context) {
	    _classCallCheck(this, MenuTabs);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.state = {
	      linkString: props.path,
	      activeLink: props.activeLink
	    };
	    return _this;
	  }
	
	  MenuTabs.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { style: styles.main },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-xs-12' },
	        this.props.items.map(function (item, i) {
	          var classes = _this2.props.items.length === 3 ? "col-sm-4 col-xs-12" : "col-sm-6 col-xs-12";
	          if (_this2.props.activeMenu === (0, _utilFunctions.prettifyUrl)(item.type)) return _react2.default.createElement(
	            'div',
	            { className: classes, key: i, style: [styles.item, styles.itemActive], onClick: function onClick() {
	                return _this2.props.clickFunc(item.type);
	              } },
	            item.name
	          );else return _react2.default.createElement(
	            'div',
	            { className: classes, key: i, style: styles.item, onClick: function onClick() {
	                return _this2.props.clickFunc(item.type);
	              } },
	            item.name
	          );
	        })
	      )
	    );
	  };
	
	  return MenuTabs;
	}(_react.Component);
	
	exports.default = (0, _radium2.default)(MenuTabs);
	
	
	var styles = {
	  main: {},
	  item: (_item = {
	    display: 'inline-block',
	    textAlign: 'center',
	    paddingTop: 20,
	    paddingBottom: 20,
	    paddingLeft: 20,
	    paddingRight: 20,
	    backgroundColor: _colors2.default.darkBlue,
	    color: '#ffffff',
	    borderLeft: 'solid #ffffff 1px'
	  }, _item[_breakpoints2.default.media.siteUnderPadWidth] = {
	    borderLeft: 'none'
	  }, _item[':hover'] = {
	    cursor: 'pointer'
	  }, _item),
	  itemActive: (_itemActive = {
	    borderBottom: 'solid #ffffff 5px',
	    paddingBottom: 15,
	    opacity: 0.8
	  }, _itemActive[_breakpoints2.default.media.siteUnderPadWidth] = {
	    borderBottom: 'none'
	  }, _itemActive)
	};

/***/ }),

/***/ "./src/components/VettrisArticle.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.VettrisArticle = undefined;
	
	var _sideBar, _mobileBlueboxes, _responsiveDivider;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__("./node_modules/radium/lib/index.js");
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _marked = __webpack_require__("./node_modules/marked/lib/marked.js");
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _MapComponent = __webpack_require__("./src/components/MapComponent.js");
	
	var _MapComponent2 = _interopRequireDefault(_MapComponent);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _data = __webpack_require__("./contentfuldata/data.json");
	
	var _data2 = _interopRequireDefault(_data);
	
	var _breakpoints = __webpack_require__("./src/utils/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _FullPageBlueItem = __webpack_require__("./src/components/FullPageBlueItem.js");
	
	var _FullPageBlueItem2 = _interopRequireDefault(_FullPageBlueItem);
	
	var _utilFunctions = __webpack_require__("./src/utils/util-functions.js");
	
	var _arkenzooVetUrls = __webpack_require__("./src/utils/arkenzoo-vet-urls.js");
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var VettrisArticle = exports.VettrisArticle = function (_Component) {
	  _inherits(VettrisArticle, _Component);
	
	  function VettrisArticle(props, context) {
	    _classCallCheck(this, VettrisArticle);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.state = {
	      linkString: props.path,
	      activeLink: props.activeLink
	    };
	    _this.changeToClinic = _this.changeToClinic.bind(_this);
	    return _this;
	  }
	
	  VettrisArticle.prototype.changeToClinic = function changeToClinic(clinic) {
	    var azVetUrl = (0, _arkenzooVetUrls.getAZVetUrl)(clinic);
	    if (azVetUrl) {
	      window.location = azVetUrl;
	    } else {
	      this.props.history.push('/' + clinic);
	    }
	  };
	
	  VettrisArticle.prototype.render = function render() {
	    var _this2 = this;
	
	    var brand = (0, _utilFunctions.getLang)();
	    var mapTitle = _data2.default.singleData[brand].singleData.frontpageMapTitle;
	    var mapItems = _data2.default.clinicsData[brand].clinicsData;
	    var text = this.props.article.aboutText || "";
	    var type = this.props.article.menu ? this.props.article.menu.fields.type : "";
	    var sideBarHeadline = this.props.article.aboutSidebar ? this.props.article.aboutSidebar.fields.blueboxArticleHeadline : "";
	    var sideBarText = this.props.article.aboutSidebar ? this.props.article.aboutSidebar.fields.blueboxArticleText : "";
	    var reviewBoxTitle = this.props.article.aboutReview ? this.props.article.aboutReview.fields.blueboxReviewTitle : "";
	    var reviewBoxName = this.props.article.aboutReview ? this.props.article.aboutReview.fields.blueboxReviewName : "";
	    var reviewBoxText = this.props.article.aboutReview ? this.props.article.aboutReview.fields.blueboxReviewText : "";
	    var reviewBoxImage = this.props.article.aboutReview && this.props.article.aboutReview.fields.blueboxReviewImage ? this.props.article.aboutReview.fields.blueboxReviewImage.fields.file.url : "";
	    var clinicOpenText = _data2.default.singleData[brand].singleData.clinicOpenTitle;
	    var clinicBookingText = _data2.default.singleData[brand].singleData.clinicBookingText;
	    var noRecruitmentText = _data2.default.singleData[brand].singleData.noRecruitmentText;
	
	    var Media = function Media() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-md-7' },
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(text) } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-md-4 col-md-offset-1' },
	          sideBarText !== "" && _react2.default.createElement(
	            'div',
	            { style: styles.sideBar, className: 'extraSidebar' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              sideBarHeadline
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(sideBarText) } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hidden-xs' },
	            ' ',
	            _react2.default.createElement(_MapComponent2.default, { items: mapItems, title: mapTitle, history: _this2.props.history })
	          )
	        )
	      );
	    };
	
	    var About = function About() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-md-7 sideBar' },
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(text) } }),
	          reviewBoxTitle !== "" && _react2.default.createElement(
	            'div',
	            { style: styles.reviewBox, className: 'reviewBox' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-4' },
	              _react2.default.createElement('img', { className: 'img-circle', src: reviewBoxImage })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-8' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                reviewBoxName
	              ),
	              _react2.default.createElement(
	                'h4',
	                null,
	                reviewBoxTitle
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                reviewBoxText
	              )
	            ),
	            _react2.default.createElement('div', { className: 'clearfix' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-md-4 col-md-offset-1 sideBar' },
	          sideBarText !== "" && _react2.default.createElement(
	            'div',
	            { style: styles.sideBar, className: 'extraSidebar' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              sideBarHeadline
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(sideBarText) } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hidden-xs' },
	            ' ',
	            _react2.default.createElement(_MapComponent2.default, { items: mapItems, title: mapTitle, history: _this2.props.history })
	          )
	        )
	      );
	    };
	
	    var Contact = function Contact() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12', style: styles.mobileBlueboxes },
	          _lodash2.default.sortBy(mapItems, function (sorted) {
	            return sorted.name;
	          }).map(function (item, i) {
	            return _react2.default.createElement(_FullPageBlueItem2.default, { key: i, name: item.name, extraText: clinicOpenText, buttonLink: item.bookingUrl,
	              buttonText: clinicBookingText + " " + item.name, location: item.coordinates,
	              phoneText: item.phoneText, phone: item.phone, clickExtraText: _this2.changeToClinic, history: _this2.props.history });
	          }),
	          _react2.default.createElement('div', { style: styles.responsiveDivider }),
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(text) } })
	        )
	      );
	    };
	
	    var Employee = function Employee() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-md-7' },
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(text) } }),
	          _lodash2.default.sortBy(mapItems, function (it) {
	            return it.recruitmentText;
	          }).map(function (clinic, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: i },
	              clinic.recruitmentText && _react2.default.createElement(
	                'div',
	                { style: styles.recruitmentActive },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  clinic.name
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { key: i },
	                  clinic.recruitmentText
	                )
	              ),
	              !clinic.recruitmentText && _react2.default.createElement(
	                'div',
	                { style: styles.recruitmentInactive },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  clinic.name
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { key: i },
	                  noRecruitmentText.replace("__EMAIL__", clinic.recruitmentEmail || "")
	                )
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-md-4 col-md-offset-1' },
	          sideBarText !== "" && _react2.default.createElement(
	            'div',
	            { style: styles.sideBar, className: 'extraSidebar' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              sideBarHeadline
	            ),
	            _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(sideBarText) } })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'hidden-xs' },
	            ' ',
	            _react2.default.createElement(_MapComponent2.default, { items: mapItems, title: mapTitle, history: _this2.props.history })
	          )
	        )
	      );
	    };
	
	    //Hard coded for now.
	    var types = {
	      "media": _react2.default.createElement(Media, null),
	      "about": _react2.default.createElement(About, null),
	      "contact": _react2.default.createElement(Contact, null),
	      "franchisee": _react2.default.createElement(About, null),
	      "employee": _react2.default.createElement(Employee, null)
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { style: styles.main, className: 'row articles' },
	      types[type]
	    );
	  };
	
	  return VettrisArticle;
	}(_react.Component);
	
	exports.default = (0, _radium2.default)(VettrisArticle);
	
	
	var styles = {
	  main: {},
	  sideBar: (_sideBar = {
	    backgroundColor: _colors2.default.darkBlue,
	    borderRadius: _breakpoints2.default.borderRadius,
	    padding: 30,
	    color: '#ffffff',
	    marginBottom: _breakpoints2.default.componentDivider,
	    marginTop: _breakpoints2.default.componentDivider
	  }, _sideBar[_breakpoints2.default.media.siteUnderPadWidth] = {
	    marginBottom: _breakpoints2.default.mobileDivider
	  }, _sideBar),
	  mobileBlueboxes: (_mobileBlueboxes = {}, _mobileBlueboxes[_breakpoints2.default.media.siteUnderPadWidth] = {
	    marginLeft: -30,
	    marginRight: -30
	  }, _mobileBlueboxes),
	  reviewBox: {
	    backgroundColor: _colors2.default.darkBlue,
	    padding: 30,
	    color: '#ffffff',
	    borderRadius: _breakpoints2.default.borderRadius
	  },
	  responsiveDivider: (_responsiveDivider = {
	    marginTop: _breakpoints2.default.componentDivider
	  }, _responsiveDivider[_breakpoints2.default.media.siteUnderPadWidth] = {
	    marginTop: _breakpoints2.default.mobileDivider
	  }, _responsiveDivider),
	  recruitmentActive: {
	    color: _colors2.default.darkBlue
	  },
	  recruitmentInactive: {
	    color: _colors2.default.lightBrown
	  }
	
	};

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/codebuild/output/src580589704/src/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/codebuild/output/src580589704/src/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/codebuild/output/src580589704/src/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/codebuild/output/src580589704/src/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/codebuild/output/src580589704/src/node_modules/babel-preset-stage-0/lib/index.js\",\"/codebuild/output/src580589704/src/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/about/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IndexPage = undefined;
	
	var _mobileContent, _mobileBreadcrumbs, _responsiveDivider, _styles;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Blueitems = __webpack_require__("./src/components/Blueitems.js");
	
	var _Blueitems2 = _interopRequireDefault(_Blueitems);
	
	var _VettrisHeader = __webpack_require__("./src/components/VettrisHeader.js");
	
	var _VettrisHeader2 = _interopRequireDefault(_VettrisHeader);
	
	var _breakpoints = __webpack_require__("./src/utils/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _data = __webpack_require__("./contentfuldata/data.json");
	
	var _data2 = _interopRequireDefault(_data);
	
	var _radium = __webpack_require__("./node_modules/radium/lib/index.js");
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _VettrisFooter = __webpack_require__("./src/components/VettrisFooter.js");
	
	var _VettrisFooter2 = _interopRequireDefault(_VettrisFooter);
	
	var _ArticleImageWithText = __webpack_require__("./src/components/ArticleImageWithText.js");
	
	var _ArticleImageWithText2 = _interopRequireDefault(_ArticleImageWithText);
	
	var _ArticleHighlight = __webpack_require__("./src/components/ArticleHighlight.js");
	
	var _ArticleHighlight2 = _interopRequireDefault(_ArticleHighlight);
	
	var _VettrisArticle = __webpack_require__("./src/components/VettrisArticle.js");
	
	var _VettrisArticle2 = _interopRequireDefault(_VettrisArticle);
	
	var _utilFunctions = __webpack_require__("./src/utils/util-functions.js");
	
	var _queryString = __webpack_require__("./node_modules/query-string/index.js");
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Breadcrumbs = __webpack_require__("./src/components/Breadcrumbs.js");
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	var _MenuTabs = __webpack_require__("./src/components/MenuTabs.js");
	
	var _MenuTabs2 = _interopRequireDefault(_MenuTabs);
	
	var _Heroimage = __webpack_require__("./src/components/Heroimage.js");
	
	var _Heroimage2 = _interopRequireDefault(_Heroimage);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = exports.IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage(props, context) {
	    _classCallCheck(this, IndexPage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.state = {
	      searchString: { menu: "" },
	      path: ""
	    };
	    _this.changeUrl = _this.changeUrl.bind(_this);
	    return _this;
	  }
	
	  IndexPage.prototype.changeUrl = function changeUrl(type) {
	    this.props.history.push('/' + this.state.path + '/#menu=' + type);
	    this.setState({
	      searchString: { menu: type }
	    });
	    (0, _utilFunctions.eventDispatch)('hashchange');
	  };
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      document.body.scrollTop = 0;
	    }, 2);
	    var brand = (0, _utilFunctions.getLang)();
	    var menuTabs = _data2.default.aboutMenuData[brand].aboutMenuData;
	    window.addEventListener("hashchange", function (e) {
	      _this2.setState({
	        searchString: { menu: window.location.hash.split("menu=")[1] }
	      });
	    });
	    this.setState({
	      path: location ? location.pathname.split('/').filter(function (strPiece) {
	        return strPiece.length > 1;
	      }) : "",
	      searchString: window.location.hash ? { menu: window.location.hash.split("menu=")[1] } : ""
	    }, function () {
	      if (!_this2.state.searchString.menu && _this2.state.path !== "") {
	        _this2.props.history.push('/' + _this2.state.path + '/#menu=' + (0, _utilFunctions.prettifyUrl)(menuTabs[1] ? menuTabs[1].type : menuTabs[0].type));
	        _this2.setState({
	          path: location ? location.pathname.split('/').filter(function (strPiece) {
	            return strPiece.length > 1;
	          }) : "",
	          searchString: window.location.hash ? { menu: window.location.hash.split("menu=")[1] } : ""
	        });
	      }
	    });
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _this3 = this;
	
	    var brand = (0, _utilFunctions.getLang)();
	    var menuTabs = _lodash2.default.sortBy(_data2.default.aboutMenuData[brand].aboutMenuData, function (item) {
	      return item.type;
	    });
	    var aboutData = _data2.default.aboutData[brand].aboutData;
	    var heroText = _data2.default.singleData[brand].singleData.frontpageHeroText;
	    var heroImage = _data2.default.singleData[brand].singleData.recruitmentHeroImage.fields.file ? _data2.default.singleData[brand].singleData.recruitmentHeroImage.fields.file.url : "";
	    var dataFromUrl = _lodash2.default.find(aboutData, function (item) {
	      return (0, _utilFunctions.prettifyUrl)(item.menu.fields.type) === _this3.state.searchString.menu;
	    }) || {};
	    var heroImageColor = "#ffffff";
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_VettrisHeader2.default, { history: this.props.history }),
	      _react2.default.createElement(_Heroimage2.default, { url: heroImage, heroText: heroText, color: heroImageColor }),
	      _react2.default.createElement(
	        _radium.StyleRoot,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: styles },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(_MenuTabs2.default, { items: menuTabs, activeMenu: this.state.searchString.menu, clickFunc: this.changeUrl })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.mobileBreadcrumbs },
	            _react2.default.createElement(_Breadcrumbs2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row', style: styles.mobileContent },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12', style: { marginTop: _breakpoints2.default.componentDivider } },
	              Object.keys(dataFromUrl).length > 0 && _react2.default.createElement(_VettrisArticle2.default, { article: dataFromUrl, history: this.props.history })
	            )
	          ),
	          _react2.default.createElement('div', { style: styles.responsiveDivider })
	        )
	      ),
	      _react2.default.createElement(_VettrisFooter2.default, null)
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = (0, _radium2.default)(IndexPage);
	
	
	var styles = (_styles = {
	  width: '100%',
	  margin: '0 auto'
	}, _styles[_breakpoints2.default.media.siteOverMaxWidth] = {
	  width: _breakpoints2.default.width.site
	}, _styles.mobileContent = (_mobileContent = {}, _mobileContent[_breakpoints2.default.media.siteUnderPadWidth] = {
	  margin: 0
	}, _mobileContent), _styles.mobileBreadcrumbs = (_mobileBreadcrumbs = {}, _mobileBreadcrumbs[_breakpoints2.default.media.siteUnderPadWidth] = {
	  margin: 0
	}, _mobileBreadcrumbs), _styles.firstRow = {
	  marginTop: _breakpoints2.default.componentDivider
	}, _styles.divider = {
	  marginTop: 20
	}, _styles.singleArticle = {
	  marginTop: 20,
	  paddingTop: 20,
	  paddingRight: 20,
	  paddingBottom: 20,
	  marginLeft: 20,
	  paddingLeft: 0
	}, _styles.typeContainer = {
	  paddingRight: 40
	}, _styles.dividerSingleItem = {
	  borderBottom: 'solid black 1px',
	  marginTop: 20,
	  paddingTop: 20,
	  paddingBottom: 20
	}, _styles.singleArticleLink = {
	  textDecoration: 'none',
	  color: _colors2.default.darkBlue
	}, _styles.responsiveDivider = (_responsiveDivider = {
	  marginTop: _breakpoints2.default.componentDivider
	}, _responsiveDivider[_breakpoints2.default.media.siteUnderPadWidth] = {
	  marginTop: _breakpoints2.default.mobileDivider
	}, _responsiveDivider), _styles);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-index-js-cbfd9ccdc907e6634cf2.js